import api from "../services/api";
import {useQuery} from "react-query";

const fetchPaymentGateways = (data) => {
  const searchParams = new URLSearchParams(data);

  return api.get(`payment-gateways?${searchParams.toString()}`).then(res => res?.data?.data);
};

export const useFetchPaymentGateways = (data = {}, options = {}) => {
  return useQuery(['payment-gateways', data], () => fetchPaymentGateways(data), options);
}
